import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { faAlignCenter } from "@fortawesome/free-solid-svg-icons";
import { Observable } from "rxjs";
import { Response } from "src/app/shared/models/Response";
import { environment } from "src/environments/environment";
import { BHEemitidaFilter } from "../models/BoletaHonorarios/BHEemitidaFilter";
import { BHErecibidaFilter } from "../models/BoletaHonorarios/BHErecibidaFilter";
import { BoletaHonorariosEmitida } from "../models/BoletaHonorarios/BoletaHonorariosEmitida";
import { BoletaHonorariosRecibida } from "../models/BoletaHonorarios/BoletaHonorariosRecibida";
import { BoletaHonorarioRequest } from "../models/BoletaHonorarios/BoletaHonorariosRequest";
import { ConciliacionRequestBHE } from "../models/BoletaHonorarios/ConciliacionRequestBHE";
import { EmailBH } from "../models/BoletaHonorarios/EmailBH";
import { EmisorDireccionBH } from "../models/BoletaHonorarios/EmisorDireccionBH";
import { Page } from "../shared/models/Page";
import { PagedResponse } from "../shared/models/PagedResponse";
import { ImportacionMasiva } from "../models/MassInvoicing/ImportacionMasiva";

@Injectable({
   providedIn: "root",
})
export class BheService {
   private REST_API_SERVER_EMITIDAS = environment.backend_server + "/BoletaHonorarioEmitida";
   private REST_API_SERVER_RECIBIDAS = environment.backend_server + "/BoletaHonorarioRecibida";

   constructor(private http: HttpClient) {}

   public getDataByPageEmitido(filter: BHEemitidaFilter, page: Page): Observable<PagedResponse<BoletaHonorariosEmitida>> {
      return this.http.get<PagedResponse<BoletaHonorariosEmitida>>(
         this.REST_API_SERVER_EMITIDAS +
            "/list/filter/" +
            "?emisorId=" +
            (filter.emisorID ? filter.emisorID : "") +
            "&nombreReceptor=" +
            (filter.nombreReceptor ? filter.nombreReceptor : "") +
            "&rutReceptor=" +
            (filter.rutReceptor ? filter.rutReceptor : "") +
            "&importacionMasivaId=" +
            (filter.importacionMasivaId ? filter.importacionMasivaId : "") +
            "&folio=" +
            (filter.folio ? filter.folio : "") +
            "&fechaEmisionDesde=" +
            (filter.fechaDesde != undefined ? filter.fechaDesde : "") +
            "&fechaEmisionHasta=" +
            (filter.fechaHasta != undefined ? filter.fechaHasta : "") +
            "&regionReceptor=" +
            (filter.regionReceptor ? filter.regionReceptor : "") +
            "&comunaReceptor=" +
            (filter.comunaReceptor ? filter.comunaReceptor : "") +
            "&pageNumber=" +
            page.pageNumber +
            "&pageSize=" +
            page.pageSize+
            "&anulada=" +
               (filter.anulada ?? "") +
            "&importada=" +
               (filter.importada ?? "") +
            "&terceros=" +
               (filter.terceros ?? "")
      );
   }

   


   public getPdf(request: BoletaHonorariosEmitida): Observable<Response<any>> {
      let boletaRequest: BoletaHonorarioRequest = new BoletaHonorarioRequest();
      boletaRequest.BH = request;
      return this.http.post<Response<any>>(this.REST_API_SERVER_EMITIDAS + "/getPdfBHE/", boletaRequest);
   }

   public sendBhe(request: BoletaHonorariosEmitida): Observable<Response<any>> {
      let boletaRequest: BoletaHonorarioRequest = new BoletaHonorarioRequest();
      boletaRequest.BH = request;
      return this.http.post<Response<any>>(this.REST_API_SERVER_EMITIDAS + "/emitBHE", boletaRequest);
   }
   


   public nullifyBHE(request: BoletaHonorarioRequest): Observable<Response<any>> {
      return this.http.post<Response<any>>(this.REST_API_SERVER_EMITIDAS + "/nullifyBHE", request);
   }
   public getEmitedDataSiiEmitidas(request: ConciliacionRequestBHE): Observable<Response<boolean>> {
      return this.http.post<Response<boolean>>(this.REST_API_SERVER_EMITIDAS + "/getEmitedDataSii", request);
   }

   public directionsForBhe(emisorId: string): Observable<Response<EmisorDireccionBH[]>> {
      return this.http.get<Response<EmisorDireccionBH[]>>(this.REST_API_SERVER_EMITIDAS + "/getDirection/" + emisorId);
   }
   public sendEmailBHEmitido(req: EmailBH): Observable<Response<any>> {
      return this.http.post<Response<any>>(this.REST_API_SERVER_EMITIDAS + "/emailBHE", req);
   }

   //recibidos
   public getDataByPageRecibido(filter: BHErecibidaFilter, page: Page): Observable<PagedResponse<BoletaHonorariosRecibida>> {
      return this.http.get<PagedResponse<BoletaHonorariosRecibida>>(
         this.REST_API_SERVER_RECIBIDAS + "/list/filter/" + "?emisorId=" + (filter.emisorID ? filter.emisorID : "") + "&nombreEmisor=" + (filter.nombreEmisor ? filter.nombreEmisor : "") + "&rutEmisorBh=" + (filter.rutEmisorBh ? filter.rutEmisorBh : "") + "&folio=" + (filter.folio ? filter.folio : "") + "&fechaEmisionDesde=" + (filter.fechaDesde != undefined ? filter.fechaDesde : "") + "&fechaEmisionHasta=" + (filter.fechaHasta != undefined ? filter.fechaHasta : "") + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize
      );
   }
   public getReceivedDataSii(request: ConciliacionRequestBHE): Observable<Response<boolean>> {
      return this.http.post<Response<boolean>>(this.REST_API_SERVER_RECIBIDAS + "/getReceivedDataSii", request);
   }
   public getPdfRecibido(request: BoletaHonorariosRecibida): Observable<Response<any>> {
      let boletaRequest: BoletaHonorarioRequest = new BoletaHonorarioRequest();
      boletaRequest.BH = JSON.parse(JSON.stringify(request)) as BoletaHonorariosEmitida;
      return this.http.post<Response<any>>(this.REST_API_SERVER_RECIBIDAS + "/getPdfBHR", boletaRequest);
   }
   public sendEmailBHRecibido(req: EmailBH): Observable<Response<any>> {
      return this.http.post<Response<any>>(this.REST_API_SERVER_RECIBIDAS + "/emailBHR", req);
   }

   public enviarObservacionBhe(request: any): Observable<any> {
		return this.http.post<Response<any>>(this.REST_API_SERVER_RECIBIDAS + "/enviarObservacion", request);
	}
}
